<template>
  <div class="app-container" style="padding: 0">
    <list
      row-key="UserId"
      ref="list"
      unit="合并工单"
      :page="page"
      show-query
      :query-params="params"
      :get-data-func="api.GetTaskDocList"
      @reset="$refs.picker.clear()"
      show-checkbox
      @check-change="onCheckChange2"
    >
      <!-- @row-select="rowSelect" -->
      <template slot="query">
        <el-form-item label="车间" label-width="100px">
          <v-select style="width: 180px" ref="typeSelect" v-model="params.DpId" clearable />
        </el-form-item>
        <el-form-item label="加工商">
          <el-select v-model="params.TradeUnitId" clearable>
            <el-option v-for="item in tradeUnitList" :key="item.TradeUnitId" :value="item.TradeUnitId" :label="item.FullName"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="Sn" label="序号" width="50"></el-table-column>
        <el-table-column prop="ProductionType" label="车间/加工商" min-width="100">
          <template slot-scope="{ row }">
            <span>{{ data.ProductionType == 1 ? row.TradeUnitName : row.DpName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="ProcessUnitName" label="加工单元" />
        <el-table-column prop="ProductNo" label="产品编码" />
        <el-table-column prop="ProductName" label="产品名称" min-width="120" />
        <el-table-column prop="BaseUnitName" label="主单位" min-width="50" />
        <el-table-column prop="BaseQuantity" label="主数量" align="right">
          <template slot-scope="{ row }">
            <span>{{ $commonJs.toThousands(row.BaseQuantity) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="SubUnitName" label="辅单位" min-width="50" />
        <el-table-column prop="SubQuantity" label="辅数量" align="right">
          <template slot-scope="{ row }">
            <span>{{ $commonJs.toThousands(row.SubQuantity) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="StockQuantity" label="现存量" align="right">
          <template slot-scope="{ row }">
            <span>{{ $commonJs.toThousands(row.StockQuantity) }}</span>
          </template>
        </el-table-column>
      </template>
    </list>
    <div style="display: flex; margin-top: -30px; float: right">
      <div style="margin-right: 10px">
        <span style="margin-right: 10px">领出仓：</span>
        <el-select v-model="params.WarehouseId" clearable>
          <el-option v-for="item in warehouseList" :key="item.WarehouseId" :label="item.WarehouseName" :value="item.WarehouseId" ></el-option>
        </el-select>
      </div>
      <el-button type="primary" @click="getDetails">查询</el-button>
    </div>
    <el-table border class="table_bottom table-line tb-c-head" :data="tableData" style="margin-top: 18px" @selection-change="onCheckChange" >
      <el-table-column type="selection" align="center" fixed :width="50" />
      <el-table-column prop="ProductNo" label="存货编码" min-width="100" align="center"></el-table-column>
      <el-table-column prop="ProductName" label="存货名称" min-width="100" align="center"></el-table-column>
      <el-table-column prop="WarehouseName" label="领出仓" min-width="100" align="center"></el-table-column>
      <el-table-column prop="PropertyName" label="属性" min-width="100" align="center">
        <template slot-scope="{ row }">
          <span>{{ row.PropertyName }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="ColorName" label="颜色" min-width="100" align="center"/>
      <el-table-column prop="Quantity" label="数量" min-width="100" align="center">
          <template slot-scope="{ row }">
            {{ $commonJs.toThousands(row.Quantity) }}
          </template>
        </el-table-column>
    </el-table>
  </div>
</template>
<script>
import listMixin from '@/mixins/list'
import list from '@/components/common/list'
import moment from 'moment'
import vSelect from '@/components/business/stock/productionpicking/vSelect'

// import iForm from '@/data/sys/user/IForm.json'

export default {
  mixins: [listMixin],
  components: {
    list,
    vSelect
  },
  props: {
    tempParams: {
      typeof: Object,
      default: () => {}
    },
    type: {
      type: Boolean,
      default: true
    },
    docType: {
      type: Number,
      default: 1
    },
    tableType: {
      type: Number,
      default: 0
    },
    consumablesType: {
      type: Number,
      default: 0
    },
    DictionaryId: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    },
    TradeUnitDisabled: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    tempParams(val) {
      console.log('val11111', val)
      this.params.status = val.status
      this.params.ProductionType = val.ProductionType
      this.params.InType = val.InType
      this.params.DpId = val.DpId
      this.params.OrderType = val.OrderType
      this.params.TradeUnitId = val.TradeUnitId
    }
  },
  data() {
    return {
      params: {
        DpId: '',
        TradeUnitId: '',
        ProductName: '',
        WarehouseId:null
      },
      data: {},
      commonApi: require('@/api/common/common').default,
      api: require('@/api/production/workDoc').default,
      tradeUnitApi: require('@/api/ba/tradeUnit').default,
      warehouseApi: require("@/api/ba/warehouse").default,
      selectList: [],
      arr: [],
      routesName: '',
      list: [],
      subList: [],
      tableData: [],
      extraList: [],
      TradeUnitId: null,
      TradeUnitDisabled: false,
      tradeUnitList: [],
      warehouseList: [],
    }
  },
  created() {
    this.getParams()
    this.getTradeUnitList()
    this.getwarehouseList()
  },
  mounted() {
    this.onClear()
    this.getData()
  },
  methods: {
    dateFormat: function (row, column) {
      var date = row[column.property]
      if (date == undefined || date == '') {
        return ''
      }
      return moment(date).format('YYYY-MM-DD')
    },
    getParams() {
      console.log('this.tempParams', this.tempParams)
      this.params.status = this.tempParams.status
      this.params.ProductionType = this.tempParams.ProductionType
      this.params.InType = this.tempParams.InType
      this.params.DpId = this.tempParams.DpId
      this.params.OrderType = this.tempParams.OrderType
      this.params.TradeUnitId = this.tempParams.TradeUnitId

      // if (this.tableType === 1) {
      //   this.params.Stage = this.tempParams.Stage
      // }
      // if(this.DictionaryId>0){
      //   this.params.ProcessStage=this.DictionaryId
      // }
    },
    
    getwarehouseList(){
      this.warehouseApi.list({}).then((res) => {
        if (res.Code === 0) {
          this.warehouseList = res.Data;
        }
      });
    },
    del() {},
    checkChange(list) {
      this.list = list
    },
    clear() {
      this.list = []
      this.subList = []
    },
    onCheckChange(list) {
      this.subList = list
    },
    getTradeUnitList() {
      this.tradeUnitApi.list({ TradeUnitTypes: [1, 2, 3] }).then(res => {
        this.tradeUnitList = res.Data
      })
    },
    getDetails() {
      console.log('getDetails', JSON.parse(JSON.stringify(this.selectList)))

      var ids = this.selectList.map(x => x.WorkDocId)
      var ProductQtys = this.selectList.map(x => {
        return {
          ProductId: x.ProductId,
          Quantity: x.BaseQuantity
        }
      })
      const o = {
        ids,
        InType: this.params.InType,
        WarehouseId: this.params.WarehouseId,
        ProductQtys,
        Disabled: 0,
      }
      console.log('🚀 ~ getDetails ~ o:', o)
      this.api.GetTaskDocInfos(o).then(res => {
        this.extraList = []
        if (res.Code === 0) {
          this.tableData = []
          res.Data.forEach(x => {
            x.Quantity = x.Quantity - (x.PrGetDocOccupyQuantity ?? 0)
          })
          let tList = res.Data.filter(item => item.Quantity > 0)
          this.tableData = [...this.tableData, ...tList]
          console.log('this.tableData', this.tableData)
        } else {
          this.$message({ type: 'warning', message: res.Msg })
        }
      })
    },
    onCheckChange2(data) {
      this.selectList = data
    },
    onClear() {
      this.selectList = []
      this.tableData = []
    }
  }
}
</script>
